import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  styleDef?: React.CSSProperties;
  clickEvent: (e: React.MouseEvent) => void;
  status?: string;
  type?: string;
  queLabel?: any;
  disabled?: boolean;
}

const SuveyButton: FC<Props> = ({
  clickEvent,
  queLabel = '',
  styleDef,
  status,
  type,
  disabled,
}) => {
  const clickEvt = (e: any) => {
    if (disabled) return;
    clickEvent(e);
  };
  return (
    <div className={['_suvey_btn_box_div', type].join(' ')}>
      <button
        className={['_btn', status, disabled ? 'disable' : ''].join(' ')}
        onClick={clickEvt}
        disabled={disabled}
      >
        <div className="_icon">
          <i className="ri-survey-line"></i>
        </div>
        {queLabel !== '' ? <div className="_label">{queLabel}</div> : ''}
      </button>
    </div>
  );
};

export default SuveyButton;
